import { jbColors } from 'theme/jbColors';

const MuiTab = {
  styleOverrides: {
    root: {
      padding: '6px 0',
      textTransform: 'none',
      fontSize: 16,
      fontWeight: 300,
      minHeight: 44,
      color: jbColors.core.reflexBlue[50],
      '& ~ &': {
        marginLeft: 30,
      },
      '@media  (min-width: 600px)': {
        minWidth: 'inherit',
      },
    },
  },
};

export default MuiTab;
